<template>
  <div class="loding">
    <div class="mainview">
      <h2>A : Young</h2>
      <div class="box">
        <span class="lorem1">L</span>
        <span class="lorem2">o</span>
        <span class="lorem3">d</span>
        <span class="lorem4">i</span>
        <span class="lorem5">n</span>
        <span class="lorem6">g</span>
        <span class="lorem7">~</span>
      </div>
    </div>
  </div>
</template>

<script>
// 화면 전환 함수
export default {
  name: "Loding",
  mounted() {
    this.homeMove();
  },
  methods: {
    homeMove() {
      setTimeout(() => {
        this.$router.push('/home');
      }, 3000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/mixin", "../sass/partials/variable";

.loding {
  background-color: $m-bg1;
  @include flex(true, 'center', 'center', 0);

  .mainview {
    h2 {
      @include font-set(bold, 5rem, 1px, $ff6);
      color: $color1;
      padding-bottom: 50px;
    }
    .box{
      width: 150px;
      height: 30px;
      @include font-set(bold, 1.5rem, 1px, $ff5);
      color: #fff;
      position: absolute;
      top: calc(50% + 40px);
      left: calc(50% - 40px);
      span{ display: inline-block; }
      .lorem1{animation: gg 2s 0.2s linear; animation-iteration-count: 1; }
      .lorem2{animation: gg 2s 0.4s linear; animation-iteration-count: 1; }
      .lorem3{animation: gg 2s 0.6s linear; animation-iteration-count: 1;}
      .lorem4{animation: gg 2s 0.8s linear; animation-iteration-count: 1;}
      .lorem5{animation: gg 2s 1s linear; animation-iteration-count: 1;}
      .lorem6{animation: gg 2s 1.2s linear; animation-iteration-count: 1;}
      .lorem7{animation: gg 2s 1.4s linear; animation-iteration-count: 1;}
    }
  }
}

@keyframes gg {
  from {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
    color: $t-c1;
  }

  to {
    -webkit-transform: rotateX(360deg);
    -o-transform: rotateX(360deg);
    transform: rotateX(360deg);
    color: $t-c1;
  }
}

@-webkit-keyframes gg {
  from {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
    color: $t-c1;
  }
  
  to {
    -webkit-transform: rotateX(360deg);
    -o-transform: rotateX(360deg);
    transform: rotateX(360deg);
    color: $t-c1; 
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loding.vue